<template>
    <div class="HeatingTable">
        <div class="flex-column">
            <div style="width: 100%; height: calc(100vh - 40px)">
                <DxDataGrid :ref="dataGridRef"
                            :data-source="dataSource"
                            :column-auto-width="true"
                            :row-alternation-enabled="true"
                            :allow-column-resizing="true"
                            :show-row-lines="true"
                            :show-borders="true"
                            @initialized="onInitialized"
                            @row-prepared="onRowPrepared"
                            @cell-prepared="onCellPrepared"
                            @toolbar-preparing="onToolbarPreparing"
                            height="100%">

                    <DxEditing :allow-updating="true"
                               :allow-deleting="true"
                               :allow-adding="true"
                               :use-icons="true"
                               mode="cell" />

                    <DxPaging :page-size="500" />
                    <DxPager :visible="false" />
                    <DxFilterRow :visible="true"
                                 apply-filter="auto" />

                    <DxScrolling show-scrollbar="always"
                                 column-rendering-mode="standard"
                                 row-rendering-mode="standard"
                                 :mode="'virtual'"
                                 :preload-enabled="false" />

                    <DxColumn data-field="id"
                              caption="#"
                              :allowEditing="false"
                              width="50"
                              alignment="center"
                              cell-template="idColumnTemplate" />
                    <DxColumn data-field="errors"
                              caption=""
                              :allowEditing="false"
                              :allowSorting="false"
                              data-type="boolean"
                              width="36"
                              alignment="center"
                              cell-template="validColumnTemplate"
                              header-cell-template="validColumnHeader" />
                    <DxColumn data-field="customerId"
                              caption="Ügyfél-azonosító"
                              header-cell-template="title-header" />
                    <DxColumn data-field="allocatorId"
                              caption="Radiátor azonosító"
                              header-cell-template="title-header" />
                    <DxColumn data-field="note"
                              caption="Megnevezés"
                              header-cell-template="title-header" />
                    <DxColumn data-field="street"
                              caption="Utca"
                              header-cell-template="title-header" />
                    <DxColumn data-field="flat"
                              caption="Lakás"
                              header-cell-template="title-header" />
                    <DxColumn data-field="name"
                              caption="Díjfizető neve"
                              header-cell-template="title-header" />
                    <DxColumn data-field="readingTime"
                              caption="Leolvasás ideje"
                              header-cell-template="title-header"
                              alignment="right"
                              data-type="datetime" />
                    <DxColumn data-field="preacu"
                              caption="Előző Mérőállás"
                              datatype="number"
                              type="fixedPoint"
                              :precision="4"
                              :allowEditing="false"
                              header-cell-template="title-header" />
                    <DxColumn data-field="acu"
                              caption="Mérőóra állása"
                              datatype="number"
                              type="fixedPoint"
                              :precision="4"
                              :allowEditing="true"
                              header-cell-template="title-header" />

                    <DxColumn caption="Akciók"
                              sortOrder="0"
                              :allow-resizing="false"
                              :allow-reordering="false"
                              :min-width="60"
                              :width="100"
                              type="buttons">
                        <DxButton :visible="visibleReplaceBtn">
                            <template #default="{ data: cellInfo }">
                                <DxBtn name="newMeter"
                                       :hint="cellInfo.row.data.needReplace && cellInfo.row.data.replaced ? 'Radiátor csere módosítása' : 'Radiátor csere regisztrálása'"
                                       icon="clock"
                                       :elementAttr="{class: cellInfo.row.data.needReplace && cellInfo.row.data.replaced ? 'replaced' : 'need-replace'}"
                                       @click="openPopup(cellInfo)" />
                            </template>
                        </DxButton>
                        <DxButton name="edit"
                                  hint="Szerkesztés"
                                  icon="background"
                                  :visible="false" />
                        <DxButton name="save"
                                  hint="Mentés"
                                  icon="check" />
                        <DxButton name="cancel"
                                  hint="Mégsem"
                                  icon="close" />
                        <DxButton name="delete"
                                  hint="Törlés"
                                  icon="trash" />
                    </DxColumn>

                    <template #title-header="{ data }">
                        <div class="d-flex">
                            <div class="flex-1 text-left">{{ data.column.caption }}</div>
                        </div>
                    </template>

                    <template #idColumnTemplate="{ data: cellInfo }">
                        {{ rowId(cellInfo) }}
                    </template>

                    <template #validColumnTemplate="{ data: cellInfo }">
                        <div v-if="cellInfo.data.errors.length > 0"
                             class="warning-icon-holder">
                            <i class="dx-icon-warning warning-icon" :title="cellInfo.data.errors.join('\n')"></i>
                        </div>
                    </template>

                    <template #validColumnHeader="{ data }">
                        <i class="dx-icon-warning warning-icon-header"></i>
                    </template>

                    <template #backbtn="{ data }">
                        <div>
                            <DxBtn name="back"
                                   hint="Vissza a feltöltésekhez"
                                   text="Vissza"
                                   icon="back"
                                   @click="backbtn" />
                        </div>
                    </template>

                    <template #uploadFile="{ data }">
                        <div>
                            <DxBtn name="upload"
                                   hint="Fájl feltöltés"
                                   text="Fájl feltöltés"
                                   icon="upload"
                                   @click="importBtnClick" />

                            <form style="display:none;">
                                <input type="file" id="fileupload" name="files" accept=".xml" @change="importFile" />
                            </form>
                        </div>
                    </template>

                </DxDataGrid>
            </div>
        </div>

        <DxPopup width="700"
                 :height="550"
                 :show-title="true"
                 :title="popupTitle"
                 :drag-enabled="false"
                 :close-on-outside-click="true"
                 :show-close-buttton="true"
                 :onInitialized="onPopupInit">

            <DxPopupToolbarItem widget="dxButton"
                                toolbar="bottom"
                                location="before"
                                :options="delBtn" />

            <DxPopupToolbarItem widget="dxButton"
                                toolbar="bottom"
                                location="after"
                                :options="regBtn" />

            <DxPopupToolbarItem widget="dxButton"
                                toolbar="bottom"
                                location="after"
                                :options="closeBtn" />

            <template #content="{ data }">
                <DxForm id="form"
                        :col-count="1"
                        :form-data="newRadiatorFormData"
                        required-mark="*"
                        label-location="top">
                    <DxGroupItem caption="Alapadatok" :col-count="2">
                        <DxSimpleItem data-field="customerId"
                                      :is-required="true"
                                      :editor-options="fieldDisabled">
                            <DxLabel text="Ügyfél-azonosító" :show-colon="false" />
                        </DxSimpleItem>
                        <DxSimpleItem data-field="replaceDate"
                                      :is-required="true"
                                      editor-type="dxDateBox"
                                      :editor-options="calendarOptions">
                            <DxLabel text="Csere ideje" :show-colon="false" />
                        </DxSimpleItem>
                    </DxGroupItem>
                    <DxGroupItem caption="Régi radiátor adatok" :col-count="2">
                        <DxSimpleItem data-field="oldAllocatorId"
                                      :is-required="true">
                            <DxLabel text="Régi radiátor azonosító száma" :show-colon="false" />
                        </DxSimpleItem>
                        <DxSimpleItem data-field="oldAcu"
                                      data-type="number"
                                      :is-required="true">
                            <DxLabel text="Régi radiátor fogy. állása a csere időpontjában" :show-colon="false" />
                        </DxSimpleItem>
                    </DxGroupItem>
                    <DxGroupItem caption="Új radiátor adatok" :col-count="2">
                        <DxSimpleItem data-field="newAllocatorId"
                                      :allowEditing="false"
                                      :is-required="true"
                                      :editor-options="fieldDisabled">
                            <DxLabel text="Új radiátor azonosító száma" :show-colon="false" />
                        </DxSimpleItem>
                        <DxSimpleItem data-field="newAcu"
                                      data-type="number"
                                      :is-required="true">
                            <DxLabel text="Új radiátor fogy. állása a csere időpontjában" :show-colon="false" />
                        </DxSimpleItem>
                    </DxGroupItem>
                </DxForm>
            </template>
        </DxPopup>

    </div>
</template>

<script>
    import DxList from "devextreme-vue/list";
    import HeatingTableService from "../services/HeatingTable.service";
    import RadiatorReplaceListService from "../services/RadiatorReplaceList.service";
    import DxForm, {
        DxItem as DxFormItem,
        DxButtonItem,
        DxLabel,
        DxGroupItem,
        DxSimpleItem
    } from "devextreme-vue/form";
    import DxPopup, {
        DxToolbarItem as DxPopupToolbarItem
    } from "devextreme-vue/popup";
    import DxToolbar, { DxItem as DxToolbarItem } from "devextreme-vue/toolbar";
    import DxSelectBox from "devextreme-vue/select-box";
    import DxDataGrid, {
        DxGrouping,
        DxGroupPanel,
        DxSearchPanel,
        DxPaging,
        DxPager,
        DxSorting,
        DxScrolling,
        DxFilterRow,
        DxColumn,
        DxEditing,
        DxLookup,
        DxRequiredRule,
        DxPopup as DxDataGridEditPopup,
        DxPosition,
        DxForm as DxDatagridEditForm,
        DxButton,
        DxColumnFixing,
        DxRowDragging
    } from "devextreme-vue/data-grid";
    import { DxScrollView } from 'devextreme-vue/scroll-view';
    import CustomStore from "devextreme/data/custom_store";
    import { DxButton as DxBtn } from 'devextreme-vue/button';
    import notify from "devextreme/ui/notify";
    import { DxLoadPanel } from 'devextreme-vue/load-panel';
    import DxDateBox, { DxCalendarOptions } from 'devextreme-vue/date-box';
    import { jsPDF } from 'jspdf';
    import 'jspdf-autotable';
    import { exportDataGrid as exportDataGridToPdf } from 'devextreme/pdf_exporter';
    import moment from 'moment';

    export default {
        name: 'HeatingTable',
        components: {
            DxPopup,
            DxFormItem,
            DxButtonItem,
            DxLabel,
            DxForm,
            DxGroupItem,
            DxSimpleItem,
            DxToolbarItem,
            DxPopupToolbarItem,
            DxSelectBox,
            DxList,
            DxGrouping,
            DxGroupPanel,
            DxSearchPanel,
            DxPaging,
            DxPager,
            DxSorting,
            DxScrolling,
            DxFilterRow,
            DxColumn,
            DxEditing,
            DxLookup,
            DxRequiredRule,
            DxPosition,
            DxDatagridEditForm,
            DxButton,
            DxDataGridEditPopup,
            DxColumnFixing,
            DxRowDragging,
            DxDataGrid,
            DxScrollView,
            DxToolbar,
            DxBtn,
            DxDateBox,
            DxCalendarOptions,
            DxLoadPanel
        },
        data() {
            return {
                datagrid: null,
                dataGridRef: null,
                popup: null,
                dataSource: new CustomStore({
                    key: "id",
                    load: () => HeatingTableService.get(this.$router.currentRoute.params.id),
                    insert: (values) => {
                        return HeatingTableService.insert(values);
                    },
                    update: (key, values, reorder) =>
                        HeatingTableService.update({
                            key: key,
                            values: JSON.stringify(values),
                            reorder: values.hasOwnProperty('OrderIndex')
                        }),
                    remove: key => HeatingTableService.delete(key)
                }),
                closeBtn: {
                    icon: 'close',
                    text: 'Mégsem',
                    onClick: () => this.popup.hide()
                },
                regBtn: {
                    icon: 'upload',
                    text: 'Regisztrálás',
                    onClick: () => this.replaceRadiator()
                },
                delBtn: {
                    icon: 'trash',
                    text: 'Törlés',
                    onClick: () => this.deleteRadiator()
                },
                calendarOptions: null,
                newRadiatorFormData: {
                    customerId: null,
                    replaceDate: null,
                    oldAllocatorId: null,
                    oldAcu: null,
                    newAllocatorId: null,
                    newAcu: null
                },
                fieldDisabled: {
                    disabled: true
                },
                popupTitle: 'Radiátor csere regisztrálása',
                editmode: false,
                editid: null
            };
        },
        methods: {
            onInitialized(e, level) {
                this.datagrid = e.component;
            },
            onRowPrepared(e) {
                if (e.rowType === "data") {
                    if (e.data.errors.length > 0) {
                        e.rowElement.classList.add('warning-row');
                    }
                }
            },
            onCellPrepared(e) {
                if (e.rowType === "filter" && e.column.dataField === "errors") {
                    e.cellElement.innerHTML = "";
                    let element = document.createElement("div");
                    e.cellElement.appendChild(element);
                    // TODO: Itt meg kell oldani a szűrhetőséget a hibás sorokra!
                    //console.log(e);
                }
            },
            rowId: function (cellInfo) {
                return cellInfo.row.rowIndex + 1;
            },
            onToolbarPreparing(e) {
                e.toolbarOptions.items.unshift({
                    location: 'before',
                    template: 'backbtn'
                });

                e.toolbarOptions.items.unshift({
                    location: 'after',
                    widget: 'dxButton',
                    options: {
                        icon: 'exportpdf',
                        text: 'Nyomtatás',
                        onClick() {
                            console.log(this.getDataGrid);
                            const doc = new jsPDF();
                            exportDataGridToPdf({
                                jsPDFDocument: doc,
                                component: this.getDataGrid,
                            }).then(() => {
                                doc.save('Customers.pdf');
                            });
                        }
                    }
                });
            },
            async openPopup(e) {
                if (this.popup) {
                    this.calendarOptions = {
                        value: moment(e.row.data.readingTime).subtract(1, 'months').set("date", 15),
                        min: moment(e.row.data.readingTime).subtract(1, 'months').startOf('month'),
                        max: moment(e.row.data.readingTime).subtract(1, 'months').endOf('month'),
                        acceptCustomValue: false
                    };

                    var replace_data = await RadiatorReplaceListService.getByAllocatorIdAndDate(e.row.data.allocatorId, moment(e.row.data.readingTime).subtract(1, 'months').set("date", 15).toISOString());

                    if (replace_data != '') {
                        this.popupTitle = 'Radiátor csere módosítása';
                        this.editmode = true;
                        this.regBtn.text = 'Módosítás';
                        this.editid = replace_data.id;

                        this.newRadiatorFormData.oldAllocatorId = replace_data.oldAllocatorId;
                        this.newRadiatorFormData.oldAcu = replace_data.oldACU;
                        this.newRadiatorFormData.customerId = replace_data.customerId;
                        this.newRadiatorFormData.newAllocatorId = replace_data.newAllocatorId;
                        this.newRadiatorFormData.replaceDate = replace_data.replaceDate;
                        this.newRadiatorFormData.newAcu = replace_data.newACU;
                    } else {
                        this.popupTitle = 'Radiátor csere regisztrálása';
                        this.editmode = false;
                        this.regBtn.text = 'Regisztrálás';

                        this.newRadiatorFormData.oldAllocatorId = null;
                        this.newRadiatorFormData.oldAcu = 0;
                        this.newRadiatorFormData.customerId = e.row.data.customerId;
                        this.newRadiatorFormData.newAllocatorId = e.row.data.allocatorId;
                        this.newRadiatorFormData.replaceDate = moment(e.row.data.readingTime).subtract(1, 'months').set("date", 15);
                        this.newRadiatorFormData.newAcu = 0;
                    }

                    this.popup.show();
                }
            },
            onPopupInit(e) {
                this.popup = e.component;
            },
            visibleReplaceBtn(e) {
                return e.row.data.needReplace;
            },
            replaceRadiator() {
                let datagrid = this.datagrid;

                if (this.editmode) {
                    RadiatorReplaceListService
                        .update({
                            key: this.editid,
                            values: JSON.stringify(this.newRadiatorFormData)
                        })
                        .then(result => {
                            if (result.status == 400) {
                                notify({
                                    message: 'A radiátor csere módosítása sikertelen!',
                                    position: {
                                        at: "top",
                                        offset: "0 40"
                                    }
                                }, "error", 5000);
                                return;
                            }

                            datagrid.refresh();

                            notify({
                                message: 'A radiátor cserét sikeresen módosítottuk!',
                                position: {
                                    at: "top",
                                    offset: "0 40"
                                }
                            }, "success", 5000);
                        });
                } else {
                    RadiatorReplaceListService
                        .insert(this.newRadiatorFormData)
                        .then(result => {
                            if (result.status == 400) {
                                notify({
                                    message: 'A radiátor csere regisztrálása sikertelen!',
                                    position: {
                                        at: "top",
                                        offset: "0 40"
                                    }
                                }, "error", 5000);
                                return;
                            }

                            datagrid.refresh();

                            notify({
                                message: 'A radiátor cserét sikeresen regisztráltuk!',
                                position: {
                                    at: "top",
                                    offset: "0 40"
                                }
                            }, "success", 5000);
                        });
                }
                this.popup.hide();
            },
            deleteRadiator() {
                let datagrid = this.datagrid;

                RadiatorReplaceListService
                    .delete(this.editid)
                    .then(result => {
                        if (result.status == 400) {
                            notify({
                                message: 'A radiátor csere törlése sikertelen!',
                                position: {
                                    at: "top",
                                    offset: "0 40"
                                }
                            }, "error", 5000);
                            return;
                        }

                        datagrid.refresh();

                        notify({
                            message: 'A radiátor csere törlése megtörtént!',
                            position: {
                                at: "top",
                                offset: "0 40"
                            }
                        }, "success", 5000);
                    });

                this.popup.hide();
            },
            backbtn() {
                this.$router.push('/heatcalculator');
            }
        },
        computed: {
            getDataGrid() {
                return this.$refs[this.dataGridRef].instance;
            },
        },
    }
</script>

<style lang="scss" scoped>
    #mapScrollview {
        height: 100%;
    }

    ::v-deep .grid {
        fill-opacity: 0;
    }

    ::v-deep .dx-scrollable {
        width: 100%;
    }

    ::v-deep .dx-scrollable-content {
        padding-bottom: 0 !important;
    }

    ::v-deep .dx-datagrid-header-panel .dx-toolbar {
        padding: 10px 10px 0px 10px;
    }

    ::v-deep .dx-datagrid-edit-popup .dx-state-readonly {
        border: none !important;
    }

    .positionid {
        display: block;
        float: left;
        width: 19px;
        text-align: right;
        margin-right: 3px;
    }

    ::v-deep .dx-datagrid, ::v-deep .dx-toolbar {
        background-color: transparent;
    }

    ::v-deep .dx-toolbar-text-auto-hide .dx-button .dx-icon {
        line-height: 20px;
    }

    ::v-deep .warning-row {
        background-color: #f9f2b1 !important;
        border-color: #f9f2b1 !important;
    }

    ::v-deep .error-row {
        background-color: #ffa1a1 !important;
        border-color: #ffa1a1 !important;
    }

    .warning-icon {
        font-size: 18px;
        color: #ff0000;
        vertical-align: bottom;
    }

    .warning-icon-header {
        font-size: 18px;
        vertical-align: bottom;
    }

    ::v-deep .replaced, ::v-deep .need-replace {
        border: none;
        background-color: unset !important;
    }

    ::v-deep .dx-button-content, ::v-deep .dx-button-content {
        padding: 0 !important;
    }

    ::v-deep .replaced i {
        color: #4caf50;
        line-height: 13px;
    }

    ::v-deep .need-replace i {
        color: #ff6a00;
        line-height: 13px;
    }
</style>